import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, LineHeightInPx } from "@snapchat/snap-design-system";

export const LensContainersDropdownOptionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 253px;
    max-height: 80vh;
`;

export const lensContainerDropdownContainer = css`
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 220px;
    height: 40px;
    padding: 5px 17px;

    background: ${Colors.Gray.V50};
    border-radius: 4px;
`;

export const ContentInfo = css`
    padding: 0 8px 0 10px;
`;

export const AccountOrg = styled.div`
    width: 135px;

    font-size: ${FontSizeInPx.COMPACT}px;
    font-weight: ${FontWeight.MEDIUM};
    line-height: ${LineHeightInPx.REGULAR}px;
    color: ${Colors.Black.V150};
    letter-spacing: 0.2px;
`;
